export default "__VITE_ASSET__Bw3O_FoC__"